export default "__VITE_ASSET__C3w2JONU__"